// src/flows/masterclass/ai/AIStepLayout.tsx
import { Box, Button, Typography } from '@mui/material';
import StepNavigator from '../components/StepNavigator';
import DosenButton from '../../../../ui/Buttons/DosenButton';

export function AIStepLayout({
  stepTitle,
  title,
  children,
  bottomContent,
  prevLabel,
  onBack,
  onNext,
  nextDisabled,
  nextLoading,
  nextLoadingLabel,
  isLastStep,
  nextLabel,
  steps
}: any) {
  return (
    <Box display="flex" flexDirection="column" height="100%" bgcolor="#0F0F0F" p={0}>
      <Box px="25px" display="flex" justifyContent="center">
        <StepNavigator currentStep={stepTitle} steps={steps} />
      </Box>
      <Box flex={1} display="flex" justifyContent="center" mt="60px" overflow="hidden">
        <Box width={600} display="flex" flexDirection="column" gap={4} maxHeight="100%" overflow="auto" pr={1}>
          <Typography color="#FDFDFD" fontSize={28} fontWeight={500}>
            {title}
          </Typography>
          {children}
        </Box>
      </Box>

      {bottomContent && (
        <Box display="flex" justifyContent="center" px="25px" pb="30px">
          <Box width={600}>{bottomContent}</Box>
        </Box>
      )}

      
      <Box borderTop="1px solid #2A2A2A" pt="25px" display="flex" justifyContent="space-between">
        <DosenButton onClick={onBack} tone="basic">
          {prevLabel || 'Previous'}
        </DosenButton>
        <DosenButton
          disabled={nextDisabled}
          loading={nextLoading}
          loadingText={nextLoadingLabel || 'Saving...'}
          onClick={onNext}
        >
          {nextLabel || (isLastStep ? 'Save' : 'Next')}
        </DosenButton>
      </Box>
    </Box>
  );
}
